@if (loading$ | async) {
  <div class="http-loader">
    <div class="http-loader__spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
}
<app-entity-toasts aria-live="polite" aria-atomic="true"></app-entity-toasts>
<router-outlet></router-outlet>